"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultState = void 0;
var _phoneAuth = require("../../types/phoneAuth");
var _requestStatus = require("../../types/requestStatus");
const defaultState = exports.defaultState = {
  registerOrAuth: {
    accounts: [],
    phoneАccounts: [],
    temporaryToken: '',
    status: _phoneAuth.ERegisterOrAuthStatus.Initial
  },
  authenticateByToken: {
    status: _phoneAuth.EAuthenticateByTokenStatus.Initial
  },
  registerOrAuthByToken: {
    status: _phoneAuth.ERegisterOrAuthByTokenStatus.Initial
  },
  sendValidationCode: {
    secondsToRetry: null,
    senderType: null,
    status: _requestStatus.ERequestStatus.Initial
  },
  checkPhone: {
    status: _phoneAuth.ECheckPhoneStatus.Initial,
    error: ''
  },
  phone: '',
  isAutosubmitEnabled: true
};